import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { NotificationBadge } from './styles';

interface LinkProps {
  urlImg: any,
  urlImgHover: any,
  path: string,
  name: string,
  isActive: boolean,
  badgeCount?: number,
}

const ItemMenu: React.FC<LinkProps> = ({name, isActive, urlImg, urlImgHover, path, badgeCount}) => {
  const [currentImage, setCurrentImage] = useState(urlImg);

  return (
    <li
      key={name}
      className={`${isActive ? "isActive" : ""}`}
      onMouseOver={!isActive ? () => {setCurrentImage(urlImgHover)} : () => {}}
      onMouseLeave={!isActive ? () => {setCurrentImage(urlImg)} : () => {}}
    >
      <Link to={path} >
        <img
          src={currentImage}
          alt="imagem"
        />
        {badgeCount ? (
          <NotificationBadge>
            {badgeCount > 99 ? "99+" : badgeCount}
          </NotificationBadge>
        ) : null}
        <span>
          {name}
        </span>
      </Link>
    </li>
  );
}

export default ItemMenu;
